export default __webpack_public_path__ + "static/media/settings.36935865.svg";